/* bryan-cart-bundle: edit or remove a Foamer Configurator build from the cart as one
   unit, rather than a line at a time - Seth S. 2026.9.15 */

(function () {
  'use strict';

  var SECTIONS = ['cart-drawer', 'cart-icon-bubble', 'main-cart-items', 'main-cart-footer'];

  function cartUpdateUrl() {
    return window.routes && window.routes.cart_update_url ? window.routes.cart_update_url : '/cart/update';
  }

  function showError(button, message) {
    var wrap = button.closest('.bryan-cart-bundle');
    var el = wrap ? wrap.querySelector('[data-bryan-bundle-error]') : null;
    if (!el) return;
    el.textContent = message;
    el.hidden = !message;
  }

  /* Hand the refreshed cart back to Dawn rather than re-rendering it here. Both
     CartItems and CartDrawerItems subscribe to this event and re-fetch their own
     section when the source is not their own, so the drawer, the cart page, the
     footer and the header bubble all update through the theme's existing path. */
  function refreshCart(parsed) {
    var handled = false;

    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'bryan-cart-bundle', cartData: parsed });
        handled = true;
      }
    } catch (e) {
      handled = false;
    }

    if (!handled) window.location.reload();
  }

  /* bryan-cart-bundle-by-id: every change to a build is worked out from a FRESH copy of the
     cart, matched on _bryan_build_id, and sent as one positional array - a quantity for every
     line, in cart order. It used to send the line keys printed into the row when the cart was
     drawn, on the belief that keys do not move. They do: Shopify re-keys lines whenever the
     cart changes and discounts are recalculated (the free shirt, the $0 kit), and a stale key
     is resolved to the first line of that variant - possibly another build's. Reading the
     cart first and sending every line's quantity in one request is atomic and needs no key.
     The same fault in the configurator's Update is what left order #5003 with a kit from a
     different build. - Seth S. 2026.10.1 */
  function buildIdOf(el) {
    var row = el.closest('[data-bryan-bundle]');
    return row ? row.getAttribute('data-bryan-bundle') : '';
  }

  function cartUrl() {
    return window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart';
  }

  /* quantityFor(line) returns the new quantity for each line of this build; every other
     line keeps what it has.

     bryan-cart-bundle-split-lines: Shopify can split one product of a build into several
     identical lines - same variant, same properties - when a discount applies to only part of
     the quantity (two builds, one free shirt line and one not). Each split line carries the
     full per-build units, so setting each one to units x N multiplied the build. The FIRST line
     of each variant takes the whole new quantity and its split siblings go to zero; Shopify
     re-splits however it likes afterwards. - Seth S. 2026.10.1 */
  function updateBuild(buildId, quantityFor) {
    return fetch(cartUrl() + '.js', { headers: { Accept: 'application/json' } })
      .then(function (response) {
        if (!response.ok) throw new Error('cart unavailable');
        return response.json();
      })
      .then(function (cart) {
        var found = false;
        var seen = {};
        var updates = (cart.items || []).map(function (line) {
          if (line.properties && line.properties._bryan_build_id === buildId) {
            found = true;
            /* a base and an add-on line of the same variant are different lines on purpose
               (bryan-fc-build-role), so siblings are matched on variant AND role */
            var sib = line.variant_id + '|' + (line.properties._bryan_build_role || '');
            if (seen[sib]) return 0;
            seen[sib] = true;
            return quantityFor(line);
          }
          return line.quantity;
        });
        if (!found) throw new Error('build not in cart');

        return fetch(cartUpdateUrl() + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ updates: updates })
        });
      });
  }
  /* end bryan-cart-bundle-by-id */

  /* bryan-cart-bundle-remove: every line of the build goes in one request. Removing
     them one at a time would be wrong as well as slow - Shopify renumbers the lines
     after each change, so the second call would delete whatever moved into the slot. */
  function removeBuild(button) {
    var buildId = buildIdOf(button);
    if (!buildId) return;

    button.setAttribute('aria-busy', 'true');
    button.disabled = true;
    showError(button, '');

    updateBuild(buildId, function () {
      return 0;
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart update failed');
        return response.json();
      })
      .then(function (parsed) {
        refreshCart(parsed);
      })
      .catch(function () {
        button.disabled = false;
        button.removeAttribute('aria-busy');
        showError(button, 'Could not remove this build. Please try again.');
      });
  }

  /* bryan-cart-bundle-quantity: a build is several lines that have to move together, so
     a bundle quantity of N sets every line to its per-build units times N. The units come
     from _bryan_build_units, written when the build was added - without it a hose sitting
     at quantity 4 could not be told apart from one build using four hoses. */
  function setBundleQuantity(input, next) {
    next = parseInt(next, 10);
    if (!next || next < 1) next = 1;

    var buildId = buildIdOf(input);
    if (!buildId) return;

    input.value = next;
    input.disabled = true;
    showError(input, '');

    updateBuild(buildId, function (line) {
      var units = parseInt(line.properties._bryan_build_units, 10);
      /* a build added before units existed has no stepper, so this is only a safeguard */
      if (!units || units < 1) return line.quantity;
      return units * next;
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart update failed');
        return response.json();
      })
      .then(function (parsed) {
        refreshCart(parsed);
      })
      .catch(function () {
        input.disabled = false;
        showError(input, 'Could not change the quantity. Please try again.');
      });
  }

  /* Dawn's cart-items answers any bubbling change with updateQuantity(dataset.index, value),
     which moves one line by position. Listening in the capture phase on document runs ahead
     of that and stops the event, so a bundle's stepper never reaches it. */
  document.addEventListener(
    'change',
    function (event) {
      var input = event.target.closest && event.target.closest('[data-bryan-bundle-qty]');
      if (!input) return;
      event.stopPropagation();
      setBundleQuantity(input, input.value);
    },
    true
  );

  /* The configurator reads the build back out of the cart itself, so only the id
     travels in the URL. Keeping the cart as the single source of truth means an
     edited build cannot drift from what is actually in it. */
  function editBuild(button) {
    var url = button.getAttribute('data-bundle-url') || '/pages/foamer-configurator';
    var id = button.getAttribute('data-bundle-id') || '';
    if (!id) return;
    window.location.href = url + (url.indexOf('?') === -1 ? '?' : '&') + 'build=' + encodeURIComponent(id);
  }

  document.addEventListener('click', function (event) {
    /* bryan-cart-bundle-parts-wide: the Hide control at the foot of the parts list closes the
       build's <details>. Focus goes back to the summary, which also scrolls it into view, so
       collapsing a long list does not leave the shopper staring at the rows below it.
       - Seth S. 2026.9.16 */
    var collapse = event.target.closest('[data-bryan-bundle-collapse]');
    if (collapse) {
      event.preventDefault();
      var row = collapse.closest('.bryan-cart-bundle');
      var parts = row ? row.querySelector('.bryan-cart-bundle__parts') : null;
      if (parts) {
        parts.open = false;
        var summary = parts.querySelector('summary');
        if (summary) summary.focus();
      }
      return;
    }
    /* end bryan-cart-bundle-parts-wide */

    var step = event.target.closest('[data-bryan-bundle-step]');
    if (step) {
      event.preventDefault();
      var wrap = step.closest('.bryan-cart-bundle__quantity');
      var input = wrap ? wrap.querySelector('[data-bryan-bundle-qty]') : null;
      if (input) {
        var by = parseInt(step.getAttribute('data-bryan-bundle-step'), 10) || 0;
        setBundleQuantity(input, (parseInt(input.value, 10) || 1) + by);
      }
      return;
    }

    var remove = event.target.closest('[data-bryan-bundle-remove]');
    if (remove) {
      event.preventDefault();
      removeBuild(remove);
      return;
    }

    var edit = event.target.closest('[data-bryan-bundle-edit]');
    if (edit) {
      event.preventDefault();
      editBuild(edit);
    }
  });
})();
